
          import $$Component from "/Users/devdog/Local Sites/tmsuper/app/public/wp-content/themes/_wp-tm-super/typescript/components/navbar/PopupAffiliateNavbar.vue?vue&type=script"
          
          import { render } from "/Users/devdog/Local Sites/tmsuper/app/public/wp-content/themes/_wp-tm-super/typescript/components/navbar/PopupAffiliateNavbar.vue?vue&type=template"
          export * from "/Users/devdog/Local Sites/tmsuper/app/public/wp-content/themes/_wp-tm-super/typescript/components/navbar/PopupAffiliateNavbar.vue?vue&type=template"
          $$Component.render = render
          export default $$Component